import { _ as __read } from '../../tslib.es6-14c74580.js';
import { useState, useEffect } from 'react';

function useIntersectionObserver(elementRef, params) {
    var _a = params.threshold, threshold = _a === void 0 ? 0 : _a, _b = params.root, root = _b === void 0 ? null : _b, _c = params.rootMargin, rootMargin = _c === void 0 ? '0%' : _c, _d = params.freezeOnceVisible, freezeOnceVisible = _d === void 0 ? false : _d;
    var _e = __read(useState(), 2), isVisible = _e[0], setIsVisible = _e[1];
    var frozen = (isVisible === null || isVisible === void 0 ? void 0 : isVisible.isIntersecting) && freezeOnceVisible;
    var updateEntry = function (_a) {
        var _b = __read(_a, 1), entry = _b[0];
        setIsVisible(entry);
    };
    useEffect(function () {
        var node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        var hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node)
            return;
        var observerParams = { threshold: threshold, root: root, rootMargin: rootMargin };
        var observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return function () { return observer.disconnect(); };
    }, [elementRef === null || elementRef === void 0 ? void 0 : elementRef.current, JSON.stringify(threshold), root, rootMargin, frozen]);
    return isVisible;
}

export { useIntersectionObserver };
